exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.toggle-button{position:relative;display:inline-block;width:40px;cursor:pointer}.toggle-button.read-only{cursor:not-allowed}.toggle-button input{display:none}.toggle-button .slider{position:absolute;cursor:pointer;left:0;right:0;bottom:0;background-color:#9b9b9b;-webkit-transition:.4s;transition:.4s}.toggle-button .slider.read-only{cursor:not-allowed}.toggle-button .slider:before{box-shadow:0 3px 1px 0 rgba(0,0,0,.1),0 1px 1px 0 rgba(0,0,0,.16),0 3px 8px 0 rgba(0,0,0,.15);position:absolute;content:\"\";height:23px;width:23px;left:0;bottom:-4px;background-color:#fff;border:.5px solid #9b9b9b;-webkit-transition:.4s;transition:.4s}.toggle-button .slider:before.read-only{cursor:not-allowed}.toggle-button input:checked+.slider{background-color:#7494ae}.toggle-button input:focus+.slider{box-shadow:0 0 1px #7494ae}.toggle-button input:checked+.slider:before{background-color:#184e78;border:.5px solid #7494ae;-webkit-transform:translateX(16px);-ms-transform:translateX(16px);transform:translateX(16px)}.toggle-button .slider.round{border-radius:34px;height:16px}.toggle-button .slider.round.read-only{opacity:.4;cursor:not-allowed}.toggle-button .slider.round:before{border-radius:50%}.toggle-button .slider.round:before.read-only{opacity:.4;cursor:not-allowed}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/Buttons/ToggleButton/ToggleButton.scss
// module id = 1531
// module chunks = 0